
class TokenLocalStorageService {
  getLocalRefreshToken() {
    const token = JSON.parse(localStorage.getItem("token"));
    return token?.refreshToken;
  }

  getLocalAccessToken() {
    const token = JSON.parse(localStorage.getItem("token"));
    return token?.accessToken;
  }

  updateLocalAccessToken(newToken) {
    let token = JSON.parse(localStorage.getItem("token"));

    token.accessToken = newToken.accessToken;
    token.refreshToken = newToken.refreshToken;
    localStorage.setItem("token", JSON.stringify(token));
  }

  getToken() {
    return JSON.parse(localStorage.getItem("token"));
  }

  setToken(token) {
    localStorage.setItem("token", JSON.stringify(token));
  }

  removeToken() {
    localStorage.removeItem("token");
  }

  set(key, value) {
    localStorage.setItem(key, value);
  }

  get(key) {
    return localStorage.getItem(key);
  }

  remove(key) {
    localStorage.removeItem(key);
  }

  clear() {
    const remember = localStorage.getItem("remember");
    const userName = localStorage.getItem("userName");
    const password = localStorage.getItem("password");
    localStorage.clear();
    localStorage.setItem("remember", remember);
    localStorage.setItem("userName", userName);
    localStorage.setItem("password", password);
    sessionStorage.clear();
  }

  setDisplayHeader(path) {
    // if (path?.toLowerCase() === "/Users") {
    //   localStorage.removeItem("headerItem");
    //   this.setobjtoStringVal("headerItem", {
    //     state: true,
    //     city: true,
    //     site: false,
    //     swapStation: false,
    //     zone: false,
    //     enterprise: true,
    //   });
    // }
    if (path?.toLowerCase() === "/assets") {
      localStorage.removeItem("headerItem");
      this.setobjtoStringVal("headerItem", {
        state: false,
        city: false,
        site: false,
        swapStation: false,
        zone: false,
        enterprise: true,
      });
    }
  }

  getDisplayHeader() {
    if (localStorage.getItem("headerItem")) {
      return JSON.parse(localStorage.getItem("headerItem"));
    } else {
      return {
        sate: true,
        city: true,
        site: true,
        swapStation: true,
        zone: true,
        enterprise: true,
      };
    }
  }

  setProfileImage(image) {
    localStorage.setItem("profileImg", image);
  }

  getProfileImage() {
    const token = localStorage.getItem("profileImg");
    return token;
  }
}

export default new TokenLocalStorageService();
